import { z } from 'zod';

export const linkField = z.object({
  title: z.string().default(''),
  href: z.string().default(''),
});
export type LinkField = z.infer<typeof linkField>;
